/**
 * Parse a date string cross-browser.
 *
 * WPGraphQL/ACF return date_time_picker values in display format, e.g.
 * "2026-03-09 12:00 am" (and post dates as ISO "2026-06-22T15:17:43"). Safari's Date
 * constructor rejects the space/am-pm form and returns `Invalid Date` (Chrome is
 * lenient), which surfaced as "Invalid Date" in the event header.
 *
 * Strategy: ISO strings (with a "T") parse reliably everywhere, so use them directly.
 * Otherwise pull the calendar date out of the leading "YYYY-MM-DD" and build a local
 * Date via the numeric constructor, which is safe in every browser. Event UI only shows
 * the calendar date, so dropping the time component is fine.
 */
export function parseDate(value?: string | null): Date | null {
  if (!value) return null
  const str = String(value).trim()

  if (str.includes("T")) {
    const iso = new Date(str)
    return isNaN(iso.getTime()) ? null : iso
  }

  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))

  const fallback = new Date(str)
  return isNaN(fallback.getTime()) ? null : fallback
}
